import { Link, NavLink } from 'react-router-dom';
import MenuBar from './Component/MenuBar';
import Sidebar from './Component/Sidebar';
import Footer from './Component/Footer';
import './AboutPage.css';
import './AboutDidiJi.css';

const AboutDidiJi = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />
            <main className="yk-about-page yk-didi-page">
                {/* <!-- Page Banner Section --> */}
                <section className="yk-about-hero" aria-labelledby="yk-didi-title">
                    <div className="yk-about-hero-image" aria-hidden="true"></div>
                    <div className="auto-container">
                        <nav className="yk-about-breadcrumb" aria-label="Breadcrumb">
                            <ol>
                                <li><Link to="/USA/Home">Home</Link></li>
                                <li aria-current="page">About Didi Ji</li>
                            </ol>
                        </nav>
                        <h1 id="yk-didi-title">About Didi Ji</h1>
                    </div>
                </section>
                {/* <!--End Banner Section --> */}

                {/* <!--About Section--> */}
                <section className="yk-didi-profile" aria-labelledby="yk-didi-name">
                    <div className="auto-container">
                        <div className="yk-didi-profile-grid">
                            {/* <!--Image Column--> */}
                            <figure className="yk-didi-portrait">
                                <div className="yk-didi-portrait-frame">
                                    <img src="https://stssevastorage.blob.core.windows.net/ykwebsite/resource/about-didi.jpg" alt="Sushri Siddheshvari Devi Ji" decoding="async" />
                                </div>
                            </figure>
                            {/* <!--Text Column--> */}
                            <div className="yk-didi-biography">
                                <div className="yk-didi-eyebrow">About Didi Ji</div>
                                <h2 id="yk-didi-name">Sushri Siddheshvari Devi Ji</h2>
                                <p>addressed as Didi Ji (respected sister), was born in the state of Punjab in Northern India and spent her formative years in Canada, graduating from York University in Toronto with a degree in linguistics. Even in early childhood, she was drawn to temples and drew great solace from visiting places of worship. While other children were lost in play, she was looking within and contemplating on the purpose of life and the phenomenon of death. Internally guided by God, she intuitively felt that life has a much higher purpose than merely eating, sleeping and accumulating wealth. The promise of a financially rewarding career did not hold any appeal for her.</p>
                                <p>After graduating from university, Didi Ji's spiritual quest led her to Jagadguru Shri Kripalu Ji Maharaj.  Shri Maharaj Ji is only the fifth personality in the past 5,000 years to be recognized as an original Jagadguru, i.e. Guru of the world. Didi Ji made a pilgrimage to India where she spent two years in Guru Ashram and was taught the intricate mysteries of the Vedas and other scriptures by Shri Kripalu Ji Maharaj Himself. She started preaching service in 1987.</p>
                            </div>
                        </div>

                        <figure className="yk-didi-quote">
                            <blockquote>
                                <p>“The responsibiltry for our actions rests with us .Yet, we cannot
                                    do anything without God gracing us with mind and intellect.
                                    So, God enables us to perform actions, but
                                    we decide what we are going to do ”</p>
                            </blockquote>
                            <figcaption>Sushri Siddheshvari Devi Ji</figcaption>
                        </figure>
                    </div>
                </section>

                <section className="yk-didi-mission" aria-labelledby="yk-didi-mission-heading">
                    <div className="auto-container">
                        <div className="yk-didi-mission-grid">
                            <div className="yk-didi-mission-heading">
                                <h2 id="yk-didi-mission-heading">Radha Madhav Society</h2>
                                <nav className="yk-didi-connect" aria-labelledby="yk-didi-connect-heading">
                                    <h3 id="yk-didi-connect-heading">Connect Us</h3>
                                    <ul>
                                        <li><a href="#" aria-label="Twitter"><span className="fab fa-twitter" aria-hidden="true"></span></a></li>
                                        <li><a href="#" aria-label="Facebook"><span className="fab fa-facebook-f" aria-hidden="true"></span></a></li>
                                        <li><a href="#" aria-label="Instagram"><span className="fab fa-instagram" aria-hidden="true"></span></a></li>
                                        <li><a href="#" aria-label="YouTube"><span className="fab fa-youtube" aria-hidden="true"></span></a></li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="yk-didi-mission-copy">
                                <p>Didi Ji is the founder of Radha Madhav Society, a non-profit charitable organization in America, Canada and Trinidad, functioning under the auspices of Jagadguru Kripalu Parishat. She is continuously striving to spread the deep spiritual teachings of Hinduism and dispel the myths and misconceptions related to it. An eloquent speaker, her mission is to simplify the eternal message of the Vedas and Shastras and awaken love for God within the hearts of seeking souls. Didi Ji's preaching is concentrated in the US, Canada, the West Indies, Singapore and Malaysia. She has inspired and transformed the lives of thousands.</p>
                                <p>With a mixture of eastern background and western upbringing, Didi Ji inspires adults, teens and children alike through her lectures, satsangs and devotional retreats. She is a vibrant speaker, a melodious singer, compassionate by nature and extremely approachable.</p>
                                {/* <!--She continuously strives to spread the deep spiritual teachings of Hinduism and dispel the myths and misconceptions related to it. She is an eloquent speaker whose mission is to simplify the eternal message of the Vedas and Shastras and awaken love for God within the hearts of seeking souls. Didi Ji’s preaching is concentrated in the US, Canada and the West Indies, although she visits other parts of the world when time allows. She has inspired and transformed the lives of thousands of seekers around the globe.--> */}
                                {/* <!--<br>
                            With a mixture of eastern background and western upbringing, Didi Ji inspires adults, teens and children alike through her lectures, chanting, camps, workshops and Camps in various parts of the U.S. and the world.--> */}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="yk-about-volunteer">
                    <div className="image-layer" aria-hidden="true" style={{ backgroundImage: 'url(https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/background/bg-pattern-1.png)' }}></div>
                    <div className="auto-container">
                        <div className="row">
                            <div className="title-column">
                                <h2>Become a vital part of Yugal Kunj &amp; make a real difference to lives of many!</h2>
                            </div>
                            <div className="link-column">
                                <NavLink to='https://portalyk.yugalkunj.org/#/volunteer/register' className="yk-about-volunteer-link"><span>join to Volunteer</span><span aria-hidden="true">→</span></NavLink>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            {/* <!--Default Section--> */}
            <Footer />
        </>
    );
};

export default AboutDidiJi;
